import { mapGetters, mapMutations } from "vuex";

export default {
    name: "TextInfoModal",
    computed: {
        ...mapGetters({
            payload: "popups/textInfoModal",
        }),
    },
    created() {
        document.getElementById("html").classList.add("hide");
    },
    methods: {
        ...mapMutations({
            changeTextInfoModal: "popups/CHANGE_TEXT_INFO_MODAL",
        }),
        goTo() {
            const { to } = this.payload.data.button;
            document.getElementById("html").classList.remove("hide");
            this.changeTextInfoModal({ status: false });
            this.$router.push(this.$localize(to));
        },
    },
};
